import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { INationality } from '../interfaces/nationality.interface';

export class NationalityModel extends BaseModel implements INationality {
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  status!: string;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  sequence?: number;

  @Expose()
  isDefault?: boolean;
}
